import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import addTaxApi from '../../../../../middleware/api/ProjectManagement/Projects/ProjectView/Invoices/addTaxApi'
import { LoadingState, ValidationError } from '../../../../../types/commonTypes'
import {
  AddTaxListState,
  GetAllTaxRelatedToCountry,
  LookupList,
  SaveAllTax,
  UpdateTax,
} from '../../../../../types/ProjectManagement/Project/ProjectView/Invoices/addTaxListTypes'
import { ApiLoadingState } from '../../../../../middleware/api/apiList'
import { RootState } from '../../../../../stateStore'

const getAllTaxRelatedToCountry = createAsyncThunk(
  'getAllTax/getAllTaxRelatedToCountry',
  async (country: string, thunkApi) => {
    try {
      return await addTaxApi.getAllTaxRelatedToCuntryList(country)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const deleteTaxDetails = createAsyncThunk(
  'getAllTax/deleteTaxDetails',
  async (taxId: number, thunkApi) => {
    try {
      return await addTaxApi.deleteTaxList(taxId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const saveTaxDetails = createAsyncThunk(
  'getAllTax/saveTaxDetails',
  async (saveTaxList: SaveAllTax, thunkApi) => {
    try {
      return await addTaxApi.saveAllTaxs(saveTaxList)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const updateTaxDetails = createAsyncThunk(
  'getAllTax/updateTaxDetails',
  async (updateTaxList: UpdateTax, thunkApi) => {
    try {
      return await addTaxApi.updateTaxs(updateTaxList)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const lookup = createAsyncThunk('getAllTax/lookup', async (_, thunkApi) => {
  try {
    return await addTaxApi.lookup()
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status as ValidationError)
  }
})

export const initialTaxListState: AddTaxListState = {
  getAllTaxRelatedToCountry: [],
  isLoading: ApiLoadingState.idle,
  saveAllTax: [],
  updateTax: [],
  lookUpList: {} as LookupList,
}
const addTaxListSlice = createSlice({
  name: 'getAllTax',
  initialState: initialTaxListState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(lookup.fulfilled, (state, action) => {
        state.lookUpList = action.payload
        state.isLoading = ApiLoadingState.succeeded
      })
      .addCase(getAllTaxRelatedToCountry.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(getAllTaxRelatedToCountry.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.getAllTaxRelatedToCountry = action.payload
      })
  },
})
const addTaxListThunk = {
  deleteTaxDetails,
  saveTaxDetails,
  updateTaxDetails,
  lookup,
  getAllTaxRelatedToCountry,
}
const isLoading = (state: RootState): LoadingState => state.addTaxList.isLoading

const getAddTaxDetailsList = (state: RootState): GetAllTaxRelatedToCountry[] =>
  state.addTaxList?.getAllTaxRelatedToCountry

const saveTaxDTOList = (state: RootState): SaveAllTax[] =>
  state.addTaxList.saveAllTax

const LookUpData = (state: RootState): LookupList =>
  state.addTaxList?.lookUpList

const addTaxListSelectors = {
  isLoading,
  getAddTaxDetailsList,
  saveTaxDTOList,
  LookUpData,
}
export const addTaxListService = {
  ...addTaxListThunk,
  actions: addTaxListSlice.actions,
  selectors: addTaxListSelectors,
}

export default addTaxListSlice.reducer
